<template>
    <section class="content">
      <div class="box box-info">
      
      <div class="p-toolbar p-component mb-4">
        <crmCustomerDialog ref="openDialog"/>
        </div>
          <!-- <a href="#"  @click.prevent="exportCSV()" v-if="this.crmCustomerLists.length > 0">
            <img src="../../../../static/img/excel.png" style="margin-top: 1em;width: 4%;float: right;"/>
         </a> -->
      <DataTable ref="po"
      :value="crmCustomerLists"
      :paginator="true"
      :rows="8" :filters="filters"
      class="p-datatable-responsive p-datatable-customers"
    >
      <Column header="S.n">
        <template #body="slotProps">
        {{slotProps.index+1}}
        </template>
      </Column>
      <Column :sortable="true"   header="Client Name" field="clientName" filterMatchMode="contains" >
         <template #filter>
           <InputText type="text" class="p-column-filter" v-model="filters['clientName']" />
         </template>
      </Column>
      <Column :sortable="true"
        header="Address"
        field="address"
        filterMatchMode="contains"
      >
      <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['address']" />
        </template>
      </Column>

    <Column :sortable="true" header="Contact Number" field="primaryContactNumber" filterMatchMode="contains" >
     <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['primaryContactNumber']" />
        </template>
      </Column>

      <Column :sortable="true" header="Secondary Contact" field="secondaryContactNumber"
       filterMatchMode="contains" >
       <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['secondaryContactNumber']" />
        </template>
      </Column>

       <Column :sortable="true" header="Email" field="email" filterMatchMode="contains" >
       <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['email']" />
        </template>
      </Column>

     <Column :sortable="true" header="Status" field="status"
      filterMatchMode="contains" >
         <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['status']" />
        </template>
      </Column>

    <Column header="Action" headerStyle="width: 11em">
        <template #body="slotProps">


            <Button icon="pi pi-pencil" class="p-button-raised p-button-success" @click="editCrmCustomer(slotProps.data)" />

            <Button icon="pi pi-trash" class="p-button-danger p-button-sm"   @click="openDialog(slotProps.data.id)"/>

        </template>
      </Column>


      </DataTable>
     </div>
     <Dialog v-model="dialogShow" @cancel="cancel" @deleted="deleteCrmCustomer"/>

   </section>

</template>
<script>
import crmCustomerDialog from '../crmDialog/crmCustomerdialog.vue'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import Dialog from '../../layout/dialog'
import globalKey from '../../../store/globalKey'
import axios from 'axios'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'

export default {
  name: 'customer',
  data() {
    return {
      displayBasic: false,
      dialogShow: false,
      columnList: '',
      filters: {}
    }
  },
  computed: {
    crmCustomerLists() {
      return this.$store.state.crm.crmCustomerLists
    }
  },
  mounted() {
    this.crmCustomerList()
    this.columnNames()
  },
  methods: {
    async deleteCrmCustomer(value) {
      if (value.trim() === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Delete reason cannot be empty!', life: 10000})
        this.dialogShow = true
        return
      }
      let deleteRe = {
        accountMasterId: this.accountId,
        deleteReason: value
      }
      let resp = await this.$store.dispatch('deleteCrmCustomer', deleteRe)
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
        this.closeDialog()
        this.dialogShow = false
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
        this.dialogShow = false
        this.closeDialog()
      }
    },
    editCrmCustomer(data) {
      this.$refs.openDialog.editCrmCustomer(data)
    },
    exportCSV() {
      let data = {
        columnList: this.columnList
      }
      axios({
        url: globalKey + '/fileDownload/excelReportAccount/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/Customer List' + '/' + this.$store.getters.fyId + '/' + data.columnList,
        method: 'get',
        headers: { 'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token },
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'customerList.xlsx'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    columnNames() {
      for (let i = 0; i < this.$refs.po.columns.length; i++) {
        this.columnList += this.$refs.po.columns[i].header + ','
      }
    },
    async crmCustomerList() {
      await this.$store.dispatch('loadCrmCustomerList')
    },
    openDialog(id) {
      this.dialogShow = true
      this.accountId = id
    },
    closeDialog() {
      this.dialogShow = false
      this.deleteReason = ''
    },
    cancel(data) {
      this.dialogShow = false
    }
  },
  components: {
    Column,
    DataTable,
    Dialog,
    InputText,
    crmCustomerDialog,
    Button
  }
}
</script>



// WEBPACK FOOTER //
// crmCustomer.vue?bfe6a728